import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import './FormattedNumInput.scss';

const propTypes = {
    placeholderText: PropTypes.string,
    decimalN: PropTypes.number,
};


export default class FormattedNumInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
        }
    }

    render() {

        const {placeholderText, isString, decimalN} = this.props;

        return(
            <NumberFormat
                displayType = 'input'
                type = 'text'
                isNumericString = {true}
                thousandSeparator=','
                decimalSeparator='.'
                decimalScale = {2}
                fixedDecimalScale={true}
                value={this.state.value}
                onValueChange={vals => this.setState({value: vals.formattedValue})}
                {...this.props}
            />
        )
    }
}

FormattedNumInput.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/FormattedNumInput/index.js